import type { FunctionComponent } from 'react';
import { Link, type LinkProps, type To } from 'react-router';

import { Button, type ButtonProps } from './Button.component.tsx';

interface NavigateButtonProps extends ButtonProps {
  to: To;
  linkProps?: Omit<LinkProps, 'to'>;
}

export const NavigateButton: FunctionComponent<NavigateButtonProps> = ({
  to,
  linkProps,
  ...props
}) => (
  <div
    onClick={(event) => {
      event.stopPropagation();
      event.preventDefault();
    }}
  >
    <Link to={to} {...linkProps}>
      <Button {...props} onClick={undefined} />
    </Link>
  </div>
);
